import { Col, DatePicker, Form, Input, Modal, Row, Select, Switch } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { Staff } from "../../entities/interfaces/staffs";
import StaffService from "../../services/staffs.service";

type Props = {
  open: boolean;
  selected?: Staff;
  onChange: () => void;
  onClose: () => void;
};

const ManageStaff = ({ open, onChange, selected, onClose }: Props) => {
  const [form] = Form.useForm<any>();
  const isCreate = !selected;
  const title = isCreate ? "Create Staff" : "Update Staff";
  const okButtonText = isCreate ? "Create" : "Update";
  if (!isCreate) {
    form.setFieldsValue({
      ...selected,
      joinedDate: dayjs(selected.joinedDate),
      // workingHours: selected.workingHours ? [dayjs(selected.workingHours)]
    });
  }

  const handleSubmit = async (values: any) => {
    const data = {
      ...values,
    };
    if (values.workingHours) {
      data.workingHourse = `${values.workingHours[0].format(
        "HH:mm"
      )}-${values.workingHours[1].format("HH:mm")}`;
    }
    const res = isCreate
      ? await StaffService.create(data)
      : await StaffService.update(selected.id, data);

    if (res?.success) {
      isCreate
        ? toast.success("Staff created")
        : toast.success("Staff updated");
      onChange();
      closeModal();
    }
  };

  const closeModal = () => {
    form.resetFields();
    onClose();
  };

  const designationOptions = [
    { label: "Stylist", value: "STYLIST" },
    { label: "Receptionist", value: "RECEPTIONIST" },
    { label: "Therapist", value: "THERAPIST" },
    { label: "Manager", value: "MANAGER" },
    { label: "Cleaner", value: "CLEANER" },
    { label: "Makeup Artist", value: "MAKEUP_ARTIST" },
    { label: "Nail Technician", value: "NAIL_TECHNICIAN" },
    { label: "Other", value: "OTHER" },
  ];

  return (
    <Modal
      title={title}
      open={open}
      onOk={form.submit}
      onCancel={closeModal}
      centered
      okText={okButtonText}
    >
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input name!" }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Phone"
          name="phone"
          rules={[{ required: true, message: "Please input phone!" }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Designation"
          name="designation"
          rules={[{ required: true, message: "Please input designation!" }]}
        >
          <Select options={designationOptions} />
        </Form.Item>
        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item label="Joined Date" name="joinedDate">
              <DatePicker className="w-full" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            {!isCreate && (
              <Form.Item label="Active Status" name="isActive">
                <Switch />
              </Form.Item>
            )}
          </Col>
        </Row>

        {/* <Form.Item label="Working Hours" name="workingHours">
          <TimePicker.RangePicker
            format={"HH:mm"}
            onChange={(value) => }
          />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default ManageStaff;
